module.exports = __webpack_public_path__ + "static/img/3.99d3636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/3.png
// module id = 7DQw
// module chunks = 0